import {useState} from 'react';
import EmptyResult from '@/components/EmptyResult';

import Card from '@/components/Card';
import BannerImgText from '@/components/BannerImgText';
import FileUpload from '@/components/FileUpload';

const RegistrationCarReadingPage = () => {
  const [file, setFile] = useState<File>();


  return (
    <div className="container">
      <BannerImgText title="Lecture d'immatriculation" img="media/ia-images/car-plate.webp" />
      <div className="grid grid-cols-2 gap-2">
        <Card title="Séléction des fichiers">
          <div className="mb-5">
            <FileUpload setFileUpload={setFile}/>
          </div>
          <div className="text-center">
            <button className="btn btn-fill btn-primary justify-center w-20" onClick={() => { console.warn(file)}}>GO</button>
          </div>
        </Card>
        <Card title="Résultat de l'analyse">
          <EmptyResult text="Aucune analyse trouvé" />
        </Card>
      </div>
    </div>
  );
}
  
export default RegistrationCarReadingPage;